import { useInfiniteQuery } from 'react-query'

import { fetchPostEventsByUserId } from 'utils/queries'

import { Event } from 'types/event'

export const useUserEvents = ({
  userId,
  eventObject = 'all',
  limit = 10,
}: {
  userId: string | null | undefined
  eventObject?: 'post' | 'all'
  limit?: number
}) => {
  return useInfiniteQuery<Array<Event>>(
    ['userEvents', [userId]],
    ({ pageParam }) =>
      fetchPostEventsByUserId(
        { userId, eventObject },
        {
          order: 'created',
          orderDirection: 'desc',
          lastVisible: pageParam,
          limit,
        },
      ),
    {
      // refetchOnMount: 'always',
      // refetchOnWindowFocus: 'always',
      getNextPageParam: (lastPage) => {
        // Very important, as the last page might not have any results
        if (!lastPage || !lastPage.length) return undefined

        return lastPage[lastPage.length - 1].created
      },
    },
  )
}
